<template>
  <v-chip small :color="status.color" :text-color="status.text_color">
    {{ status.text }}
  </v-chip>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    statuses: {
      draft: {
        text: "Rascunho",
        color: "",
        text_color: "black",
      },

      ready: {
        text: "Pronto",
        color: "primary",
        text_color: "white",
      },

      converted: {
        text: "Convertido",
        color: "success",
        text_color: "white",
      },

      canceled: {
        text: "Cancelado",
        color: "error",
        text_color: "white",
      },
    },
  }),

  computed: {
    status() {
      return this.statuses[this.value] || { text: this.value, color: "grey" };
    },
  },
};
</script>
